var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeekbarLive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb5757;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.53,21.67v9.55h7.25V29.45H36.63V27.11h4.62V25.48H36.63v-2h5V21.67Zm-5.32,9.55,3.17-9.55H30.21l-2.15,6.71h0l-2.12-6.71H23.75l3.09,9.55Zm-9.72-9.55v9.55h2.1V21.67Zm-9.27,0v9.55H17V29.45H12.32V21.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekbarLive);
export default __webpack_public_path__ + "static/media/seekbar-live.472005d9eb58c94ed754ed2359b700e1.svg";
export { ForwardRef as ReactComponent };